export default __webpack_public_path__ + "static/media/SberLogo-20.a1f2e7a4.svg";